<template>
  <div class="ch-container">
    <div class="ch-box">
<!--       <filtrate-view :list="filtrate" @select="onSelect"/>-->
      <result-table :list="list" />
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total,  prev, pager, next, jumper"
        :current-page="query.page"
        :page-sizes="[10, 20, 30, 100]"
        :page-size="query.size"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
import resultTable from "../components/resultTable";
import filtrateView from '../components/filtrate';
import announcement from "@/api/announcement/announcement"
export default {
  created(){
    this.queryResultBulletinList()
  },
  data() {
    return {

      total: 10,
      query:{
        type:4,
        page:1,
        size:10
      },
      list: [],
      filtrate: [
        {
          title: "发布时间:",
          active: 0,
          value: [
            { label: "全部", value: "0" },
            { label: "今天" },
            { lable: "最近3天" },
            { lable: "最近7天" },
            { lable: "最近1个月" },
            { lable: "最近3个月" },
          ],
        },
      /*  {
          title: "分类:",
          active: 0,
          value: [
            { label: "全部", value: "0" },
            { label: "工程" },
            { label: "货物" },
            { label: "服务" }
          ],
        },*/
     /*   {
          title: "地区:",
          active: 0,
          value: [
            { label: "全部", value: "0" },
            { label: "成都" },
            { label: "绵阳" },
            { label: "达州" },
            { label: "德阳" },
            { label: "内江" },
          ],
        },*/
      ],

    };
  },
  components: {
    resultTable,
    filtrateView
  },
   methods:{
    // 筛选
    onSelect({index,v_index}){
      this.filtrate[index].active=v_index;
    },
     queryResultBulletinList(){
       announcement.queryBulletinList(this.query).then(res=>{
        if (res.code===0){
            this.list=res.data.list;
            this.total=res.data.count;
        }
      })
     },
       handleSizeChange(val){
           this.query.size=val;
           this.queryResultBulletinList()
       },
       handleCurrentChange(val){
           this.query.page=val;
           this.queryResultBulletinList()
       }
  }
};
</script>

<style lang="less" scoped>
.ch-box {
  background-color: #ffffff;
  border-top: 3px solid #3984f7;
  padding: 30px;
}
.el-pagination {
    text-align: center; 
     margin-top: 20px;
}
</style>